export default [
  
  {
    path: "/settings/approval",
    name: "Approval",
    component: () => import("@/views/3pl/Settings/Approval/index"),
  },
  {
    path: "/settings/approval/createworkflow",
    name: "createApprovalWorkFlow",
    component: () => import("@/views/3pl/Settings/Approval/CreateWorkFlow.vue"),
  },
  {
    path: "/settings/approval/editworkflow",
    name: "editApprovalWorkFlow",
    component: () => import("@/views/3pl/Settings/Approval/EditWorkFlow.vue"),
  },
 
];
